export default __webpack_public_path__ + "static/media/greg.5dc6da01.jpg";